<template>
    <div>
        <v-card elevation="0">
            <v-card-title>Gender Records</v-card-title>
            <v-card-text>
                <v-simple-table>
                    <template>
                        <tbody>
                            <tr>
                                <th style="width: 20%;">Male</th>
                                <td>
                                    <v-progress-linear
                                        v-model="records_gender.Male"
                                        color="#21B6A8"
                                        height="25"
                                    >
                                        <strong>{{metadata["records_gender"]["Male"]}} / {{ records_gender.total }}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                            <tr>
                                <th style="width: 20%;">Female</th>
                                <td>
                                    <v-progress-linear
                                        v-model="records_gender.Female"
                                        color="#C26DBC"
                                        height="25"
                                    >
                                        <strong>{{metadata["records_gender"]["Female"]}} / {{ records_gender.total }}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                            <tr>
                                <th style="width: 20%;">Non-Binary</th>
                                <td>
                                    <v-progress-linear
                                        v-model="records_gender.NonBinary"
                                        color="#2E8BC0"
                                        height="25"
                                    >
                                        <strong>{{metadata["records_gender"]["NonBinary"]}} / {{ records_gender.total }}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-title>Rommate Requests</v-card-title>
            <v-card-text>
                <v-simple-table>
                    <template>
                        <tbody>
                            <tr>
                                <th style="width: 20%;" :rowspan="2">Male</th>
                                <td style="width: 25%;">With Roommate Request</td>
                                <td>
                                    <v-progress-linear
                                        v-model="paired.Male.WithRequest"
                                        color="#18A558"
                                        height="25"
                                    >
                                        <strong>{{metadata["pairedbyname_Male"]["totalWithRoommateRequests"]}} / {{ metadata["records_gender"]["Male"] }}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 25%;">Without Roommate Request</td>
                                <td>
                                    <v-progress-linear
                                        v-model="paired.Male.WithoutRequest"
                                        color="#FB4570"
                                        height="25"
                                    >
                                        <strong>{{metadata["pairedbyname_Male"]["totalWithoutRoommateRequests"]}} / {{ metadata["records_gender"]["Male"] }}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                            <tr>
                                <th style="width: 20%;" :rowspan="2">Female</th>
                                <td style="width: 25%;">With Roommate Request</td>
                                <td>
                                    <v-progress-linear
                                        v-model="paired.Female.WithRequest"
                                        color="#18A558"
                                        height="25"
                                    >
                                        <strong>{{metadata["pairedbyname_Female"]["totalWithRoommateRequests"]}} / {{metadata["records_gender"]["Female"]}}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 25%;">Without Roommate Request</td>
                                <td>
                                    <v-progress-linear
                                        v-model="paired.Female.WithoutRequest"
                                        color="#FB4570"
                                        height="25"
                                    >
                                        <strong>{{metadata["pairedbyname_Female"]["totalWithoutRoommateRequests"]}} / {{ metadata["records_gender"]["Female"] }}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                            <tr>
                                <th style="width: 20%;" :rowspan="2">Non-Binary</th>
                                <td style="width: 25%;">With Roommate Request</td>
                                <td>
                                    <v-progress-linear
                                        v-model="paired.NonBinary.WithRequest"
                                        color="#18A558"
                                        height="25"
                                    >
                                        <strong>{{metadata["pairedbyname_NonBinary"]["totalWithRoommateRequests"]}} / {{ metadata["records_gender"]["NonBinary"] }}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 25%;">Without Roommate Request</td>
                                <td>
                                    <v-progress-linear
                                        v-model="paired.NonBinary.WithoutRequest"
                                        color="#FB4570"
                                        height="25"
                                    >
                                        <strong>{{metadata["pairedbyname_NonBinary"]["totalWithoutRoommateRequests"]}} / {{ metadata["records_gender"]["NonBinary"] }}</strong>
                                    </v-progress-linear>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-title>Building Choices</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="4">
                        <b>Alumni Court: {{buildingStats["alumni"]["total"]}}/{{records_gender["total"]}} </b>&#40;total first year students&#41;<br />
                        <v-row>
                            <v-col cols="6">
                                <span>As a first choice</span><br />
                                <v-progress-circular
                                    :rotate="-90"
                                    style="transform: scaleX(-1)"
                                    :size="100"
                                    :width="15"
                                    :value="buildingStats.alumni.choice1"
                                    color="#C26DBC"
                                >
                                    <span style="transform: scaleX(-1)">{{buildingStats["alumni"]["choice1"]}}%</span>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="6">
                                <span>As a second choice</span><br />
                                <v-progress-circular
                                    :rotate="-90"
                                    :size="100"
                                    :width="15"
                                    :value="buildingStats.alumni.choice2"
                                    color="#1592B4"
                                >
                                    {{buildingStats["alumni"]["choice2"]}}%
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <b>Townhouse: {{buildingStats["townhouse"]["total"]}}/{{records_gender["total"]}} </b>&#40;total first year students&#41;<br />
                        <v-row>
                            <v-col cols="6">
                                <span>As a first choice</span><br />
                                <v-progress-circular
                                    :rotate="-90"
                                    style="transform: scaleX(-1)"
                                    :size="100"
                                    :width="15"
                                    :value="buildingStats.townhouse.choice1"
                                    color="#C26DBC"
                                >
                                    <span style="transform: scaleX(-1)">{{buildingStats["townhouse"]["choice1"]}}%</span>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="6">
                                <span>As a second choice</span><br />
                                <v-progress-circular
                                    :rotate="-90"
                                    :size="100"
                                    :width="15"
                                    :value="buildingStats.townhouse.choice2"
                                    color="#1592B4"
                                >
                                    {{buildingStats["townhouse"]["choice2"]}}%
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <b>Monsignor Wemple: {{buildingStats["wemple"]["total"]}}/{{metadata["records_gender"]["Female"]}} </b>&#40;total first year female students&#41;<br />
                        <v-row>
                            <v-col cols="6">
                                <span>As a first choice</span><br />
                                <v-progress-circular
                                    :rotate="-90"
                                    style="transform: scaleX(-1)"
                                    :size="100"
                                    :width="15"
                                    :value="buildingStats.wemple.choice1"
                                    color="#C26DBC"
                                >
                                    <span style="transform: scaleX(-1)">{{buildingStats["wemple"]["choice1"]}}%</span>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="6">
                                <span>As a second choice</span><br />
                                <v-progress-circular
                                    :rotate="-90"
                                    :size="100"
                                    :width="15"
                                    :value="buildingStats.wemple.choice2"
                                    color="#1592B4"
                                >
                                    {{buildingStats["wemple"]["choice2"]}}%
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <br />
                <b>Placement: </b><br />
                <v-row justify="left">
                    <v-col cols="4">Number of students placed in <b>Alumni Court</b>:</v-col>
                    <v-col cols="8">
                        <v-progress-linear
                            v-model="buildingStats.totalnumberPlaced.alumniPercentage"
                            color="#189AB4"
                            height="25"
                        >
                            <strong>{{ buildingStats["totalnumberPlaced"]["alumni"] }}/{{records_gender["total"]}}</strong>
                        </v-progress-linear>
                    </v-col>
                    <v-col cols="4">Number of students placed in <b>Townhouse</b>:</v-col>
                    <v-col cols="8">
                        <v-progress-linear
                            v-model="buildingStats.totalnumberPlaced.townhousePercentage"
                            color="#189AB4"
                            height="25"
                        >
                            <strong>{{ buildingStats["totalnumberPlaced"]["townhouse"] }}/{{records_gender["total"]}}</strong>
                        </v-progress-linear>
                    </v-col>
                    <v-col cols="4">Number of students placed in <b>Monsignor Wemple</b>:</v-col>
                    <v-col cols="8">
                        <v-progress-linear
                            v-model="buildingStats.totalnumberPlaced.wemplePercentage"
                            color="#189AB4"
                            height="25"
                        >
                            <strong>{{ buildingStats["totalnumberPlaced"]["wemple"] }}/{{records_gender["total"]}}</strong>
                        </v-progress-linear>
                    </v-col>
                    <v-col cols="4">Number of students <b>NOT</b> placed in any building:</v-col>
                    <v-col cols="8">
                        <v-progress-linear
                            v-model="buildingStats.totalnumberPlaced.unplacedPercentage"
                            color="#F79489"
                            height="25"
                        >
                            <strong>{{ buildingStats["totalnumberPlaced"]["unplaced"] }}/{{records_gender["total"]}}</strong>
                        </v-progress-linear>
                    </v-col>
                </v-row>
            </v-card-text><br />
        </v-card>
    </div>
</template>
<script>
export default {
    props: {
        metadata: {
            required: true
        }
    },
    data(){
        return {
            records_gender: {},
            paired: {},
            buildingStats: {}
        }
    },
    methods: {
        initialize(){
            const that = this;

            let gendertotal = 0;

            if(that.metadata.hasOwnProperty("records_gender")){
                gendertotal = that.metadata["records_gender"]["Male"]+that.metadata["records_gender"]["Female"]+that.metadata["records_gender"]["NonBinary"];
                that.records_gender = {
                    "Male": that.calculatePercentage(that.metadata["records_gender"]["Male"], gendertotal),
                    "Female": that.calculatePercentage(that.metadata["records_gender"]["Female"], gendertotal),
                    "NonBinary": that.calculatePercentage(that.metadata["records_gender"]["NonBinary"], gendertotal),
                    "total": gendertotal
                };
            }
            
            if(that.metadata.hasOwnProperty("pairedbyname_Male") && that.metadata.hasOwnProperty("pairedbyname_Female") && that.metadata.hasOwnProperty("pairedbyname_NonBinary")){
                that.paired = {
                    "Male": {
                        "WithRequest": that.calculatePercentage(that.metadata["pairedbyname_Male"]["totalWithRoommateRequests"], that.metadata["records_gender"]["Male"]),
                        "WithoutRequest": that.calculatePercentage(that.metadata["pairedbyname_Male"]["totalWithoutRoommateRequests"], that.metadata["records_gender"]["Male"]),
                    },
                    "Female": {
                        "WithRequest": that.calculatePercentage(that.metadata["pairedbyname_Female"]["totalWithRoommateRequests"], that.metadata["records_gender"]["Female"]),
                        "WithoutRequest": that.calculatePercentage(that.metadata["pairedbyname_Female"]["totalWithoutRoommateRequests"], that.metadata["records_gender"]["Female"]),
                    },
                    "NonBinary": {
                        "WithRequest": that.calculatePercentage(that.metadata["pairedbyname_NonBinary"]["totalWithRoommateRequests"], that.metadata["records_gender"]["NonBinary"]),
                        "WithoutRequest": that.calculatePercentage(that.metadata["pairedbyname_NonBinary"]["totalWithoutRoommateRequests"], that.metadata["records_gender"]["NonBinary"]),
                    }
                }
            }else {
                that.paired = {
                    "Male": {
                        "WithRequest": 0,
                        "WithoutRequest": 0
                    },
                    "Female": {
                        "WithRequest": 0,
                        "WithoutRequest": 0
                    },
                    "NonBinary": {
                        "WithRequest": 0,
                        "WithoutRequest": 0
                    }
                }
            }

            that.buildingStats = {
                "alumni": {
                    "total": that.metadata["buildingChoice_1_Alumni Court"] + that.metadata["buildingChoice_2_Alumni Court"],
                    "choice1": that.calculatePercentage(that.metadata["buildingChoice_1_Alumni Court"], that.metadata["buildingChoice_1_Alumni Court"] + that.metadata["buildingChoice_2_Alumni Court"]),
                    "choice2": that.calculatePercentage(that.metadata["buildingChoice_2_Alumni Court"], that.metadata["buildingChoice_1_Alumni Court"] + that.metadata["buildingChoice_2_Alumni Court"])
                },
                "townhouse": {
                    "total": that.metadata["buildingChoice_1_Townhouse"] + that.metadata["buildingChoice_2_Townhouse"],
                    "choice1": that.calculatePercentage(that.metadata["buildingChoice_1_Townhouse"], that.metadata["buildingChoice_1_Townhouse"] + that.metadata["buildingChoice_2_Townhouse"]),
                    "choice2": that.calculatePercentage(that.metadata["buildingChoice_2_Townhouse"], that.metadata["buildingChoice_1_Townhouse"] + that.metadata["buildingChoice_2_Townhouse"]),
                },
                "wemple": {
                    "total": that.metadata["buildingChoice_1_Monsignor Wemple"] + that.metadata["buildingChoice_2_Monsignor Wemple"],
                    "choice1": that.calculatePercentage(that.metadata["buildingChoice_1_Monsignor Wemple"], that.metadata["buildingChoice_1_Monsignor Wemple"] + that.metadata["buildingChoice_2_Monsignor Wemple"]),
                    "choice2": that.calculatePercentage(that.metadata["buildingChoice_2_Monsignor Wemple"], that.metadata["buildingChoice_1_Monsignor Wemple"] + that.metadata["buildingChoice_2_Monsignor Wemple"])
                },
                "totalnumberPlaced": {
                    "alumni": that.metadata["buildingPlacementCount_Alumni Court"],
                    "townhouse": that.metadata["buildingPlacementCount_Townhouse"],
                    "wemple": that.metadata["buildingPlacementCount_Monsignor Wemple"],
                    "unplaced": that.metadata["buildingUnplacedCount"],
                    "alumniPercentage": that.calculatePercentage(that.metadata["buildingPlacementCount_Alumni Court"], that.records_gender.total),
                    "townhousePercentage": that.calculatePercentage(that.metadata["buildingPlacementCount_Townhouse"], that.records_gender.total),
                    "wemplePercentage": that.calculatePercentage(that.metadata["buildingPlacementCount_Monsignor Wemple"], that.records_gender.total),
                    "unplacedPercentage": that.calculatePercentage(that.metadata["buildingUnplacedCount"], that.records_gender.total),
                }
            }
            
        },
        calculatePercentage(value, total){
            return Math.round((100 * value)/total)
        }
    },
    created(){
        const that = this;
        that.initialize();
    }
}
</script>